export default __webpack_public_path__ + "static/media/King_02.6d3811dc.png";